import React, { useState, useMemo, useEffect, useRef } from "react";
import moment from "moment";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  Chip,
  Box,
  IconButton,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  CircularProgress,
  Dialog,
  DialogContent,
} from "@mui/material";
import StoreSearch from "../../../Campaign/StoreSearch";
import Decrypt from "../../../../../shared/utils/Decrypt";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styles from "../../JobBatch.module.css";
import PdfIcon from "../../../../../shared/assets/icons/PdfIcon.png";
import ModalToUpdateBatches from "../../ModalToUpdateBatches";
import RecceReport from "../../../../RFPDashboard/RecceApproval/RecceReport";

const Incomplete = ({
  setIncompleteBatches,
  incompleteBatches,
  isAllBatchesLoading,
  forbatch,
  acceptedBatches,
  setAcceptedBatches,
  setTotalIncompleteBatches,
  setAvailableBatches,
  fetchAllJobsBasedOnCampaignId,
  fetchAllBatchesBasedOnCampaignId,
  setIsNotAccepted,
  campaignData, // Make sure this prop is passed from parent
}) => {
  const [expandedBatch, setExpandedBatch] = React.useState(null);
  const [openModalToUpdateBatch, setOpenModalToUpdateBatch] =
    React.useState(false);
  const [detailsOfBatchSelected, setDetailsOfBatchSelected] = React.useState();
  const [isPaymentAmount, setPaymentAmount] = React.useState(0);
  const [openRecceReport, setOpenRecceReport] = useState(false);
  const [currentRecceJob, setCurrentRecceJob] = useState(null);
  const batchRefs = useRef({});
  const containerRef = useRef(null);

  // Check if Recce service is needed in this campaign
  const isRecceNeeded =
    campaignData?.scopeOfWork?.servicesNeeded?.includes("Recce");

  const handleAccordionToggle = (batchTitle) => (event) => {
    event.stopPropagation();
    setExpandedBatch((prev) => (prev === batchTitle ? null : batchTitle));
  };
  // Function to handle opening the recce report
  const handleOpenRecceReport = (job) => {
    setCurrentRecceJob(job);
    setOpenRecceReport(true);
  };

  // Function to handle closing the recce report
  const handleCloseRecceReport = () => {
    setOpenRecceReport(false);
  };

  // Handle batch updates when IP is assigned/unassigned
  const handleBatchUpdate = (updatedBatch) => {
    if (!updatedBatch.installationPartnerId) {
      setAcceptedBatches((prev) =>
        prev.filter((b) => b._id !== updatedBatch._id),
      );
      if (typeof setIsNotAccepted === "function") {
        setIsNotAccepted((prev) => [...prev, updatedBatch]);
      }
    } else {
      setAcceptedBatches((prev) =>
        prev.map((b) => (b._id === updatedBatch._id ? updatedBatch : b)),
      );
    }

    if (detailsOfBatchSelected?._id === updatedBatch._id) {
      setDetailsOfBatchSelected(updatedBatch);
    }
  };

  // Handle the logic to update batches with jobs

  // useEffect(() => {
  //   if (forbatch && acceptedBatches.length > 0) {
  //     const updatedBatches = acceptedBatches.map((batch) => ({
  //       ...batch,
  //       jobs: [],
  //     }));

  //     forbatch.forEach((job) => {
  //       const batch = updatedBatches.find(
  //         (batch) => batch._id === job.batchOfJobsForInstallationPartnerId
  //       );
  //       if (batch) {
  //         batch.jobs.push(job);
  //       }
  //     });

  //     // Filter jobs by status and completion date
  //     updatedBatches.forEach((batch) => {
  //       if (batch.jobs.length > 0) {
  //         const today = new Date();
  //         batch.jobs = batch.jobs.filter((job) => {
  //           const completionDate = new Date(job.jobCompletionDate);
  //           // Include completed jobs and pending jobs with a completion date in the past or today
  //           return (
  //             job.status === 2 || (job.status === 0 && completionDate <= today)
  //           );
  //         });

  //         // Calculate the date range for each batch (if any jobs left)
  //         if (batch.jobs.length > 0) {
  //           const jobDates = batch.jobs.map(
  //             (job) => new Date(job.jobStartingDate)
  //           );
  //           const completionDates = batch.jobs.map(
  //             (job) => new Date(job.jobCompletionDate)
  //           );

  //           const earliestDate = new Date(
  //             Math.min(...jobDates.map((date) => date.getTime()))
  //           );
  //           const latestDate = new Date(
  //             Math.max(...completionDates.map((date) => date.getTime()))
  //           );

  //           batch.dateRange = `${earliestDate.toLocaleDateString()} - ${latestDate.toLocaleDateString()}`;
  //           batch.totalPayment = batch.jobs.reduce(
  //             (sum, job) => sum + (job.paymentAmount || 0),
  //             0
  //           );
  //         } else {
  //           batch.dateRange = "No Dates Available";
  //           batch.totalPayment = 0;
  //         }
  //       }
  //     });

  //     setAcceptedBatches((prevBatches) => {
  //       const prevBatchesString = JSON.stringify(prevBatches);
  //       const updatedBatchesString = JSON.stringify(updatedBatches);
  //       return prevBatchesString !== updatedBatchesString
  //         ? updatedBatches
  //         : prevBatches;
  //     });

  //     // Update total incomplete batches count
  //     const incompleteBatchesCount = updatedBatches.filter((batch) =>
  //       batch.jobs.some(
  //         (job) =>
  //           job.status === 0 && new Date(job.jobCompletionDate) < new Date()
  //       )
  //     ).length;
  //     setTotalIncompleteBatches(incompleteBatchesCount);
  //   }
  // }, [
  //   forbatch,
  //   acceptedBatches,
  //   setAcceptedBatches,
  //   setTotalIncompleteBatches,
  // ]);

  const searchData = useMemo(() => {
    const result = [];

    incompleteBatches.forEach((batch) => {
      batch.jobs?.forEach((job) => {
        result.push({
          id: job._id,
          storeName: job.storeName,

          batchTitle: batch.batchTitle,

          targetId: batch._id,

          subText: `Batch: ${batch.batchTitle}`,
        });
      });
    });

    return result;
  }, [incompleteBatches]);

  return (
    <Grid ref={containerRef} className={`${styles.scrollableContainer}`}>
      <div
        className="mx-3 py-2 sticky top-0 z-20 bg-white"
        
      >
        <StoreSearch
          data={searchData}
          searchKey="storeName"
          placeholder="Search Store Name"
          containerRef={containerRef}
          targetRefs={batchRefs}
          onSelect={(item) => {
            setExpandedBatch(item.batchTitle);
          }}
        />
      </div>
      {isAllBatchesLoading ? (
        <div className={styles.noJobsStyle}>
          <CircularProgress />
        </div>
      ) : incompleteBatches.length === 0 ? (
        <div className={styles.noJobsStyle}>
          <Typography
            className={`${styles.noJobsBox} ${styles.noJobsText}`}
            variant="h6"
            align="center"
          >
            No batches available
          </Typography>
        </div>
      ) : (
        incompleteBatches.map((batch, index) => {
          const totalPayment = batch?.jobs?.reduce(
            (acc, job) => acc + (job.paymentAmount || 0),
            0,
          );

          return (
            <Grid
              ref={(el) => (batchRefs.current[batch._id] = el)}
              item
              xs={12}
              md={12}
              key={index}
              my={1}
              mx={2}
            >
              <Accordion expanded={expandedBatch === batch.batchTitle}>
                <AccordionSummary
                  expandIcon={
                    <IconButton
                      onClick={handleAccordionToggle(batch.batchTitle)}
                    >
                      <ExpandMoreIcon />
                    </IconButton>
                  }
                  aria-controls={`panel-${index}-content`}
                  id={`panel-${index}-header`}
                >
                  <div className="flex items-center justify-between p-4 rounded-lg bg-white w-full mx-auto">
                    {/* Section 1: Batch Title */}
                    <div className="flex">
                      <h1 className={styles.batchTitle}>{batch.batchTitle}</h1>
                    </div>

                    {/* Section 2: Other Details */}
                    <div className={styles.chipContainer}>
                      {/* Date Range */}
                      <div>
                        <Chip
                          label={`Timeline: ${moment(
                            batch?.jobStartingDate,
                          ).format("DD MMM YY")} - ${moment(
                            batch?.jobCompletionDate,
                          ).format("DD MMM YY")}`}
                          className={styles.chip}
                        />
                      </div>

                      {/* User Info */}
                      <Chip
                        label={
                          batch.installationPartnerId
                            ? `${batch.installationPartnerId.name} - ${
                                Decrypt(
                                  batch.installationPartnerId.phoneNumber,
                                ) || "N/A"
                              }`
                            : "No Contact Info"
                        }
                        className={styles.chip}
                      />
                      {/* Status Badge */}
                      <Chip
                        label={
                          batch.jobs?.every((job) => job.status === 2)
                            ? "Complete"
                            : `Pending: ${
                                batch.jobs?.filter((job) => job.status === 0)
                                  .length || 0
                              }`
                        }
                        className={
                          batch.jobs?.every((job) => job.status === 2)
                            ? styles.amountPaid
                            : styles.pending
                        }
                      />
                      {/* <Chip label={batch.status} className={styles.pending} /> */}
                      {/* Ellipsis Button */}
                      <Chip
                        label={
                          <span>Batch Payment: ₹{batch?.totalPayment}</span>
                        }
                        className={styles.chip}
                      />
                      <Chip
                        label={<span>Jobs: {batch?.jobs?.length || 0}</span>}
                        className={styles.chip}
                      />

                      <button
                        className="text-gray-400 hover:text-gray-600 text-xl rounded-full px-4 py-1 hover:bg-gray-100"
                        onClick={() => {
                          setOpenModalToUpdateBatch(true);
                          setDetailsOfBatchSelected(batch);
                          setPaymentAmount(totalPayment);
                        }}
                      >
                        ⋮
                      </button>
                    </div>
                  </div>
                </AccordionSummary>

                <AccordionDetails className={styles.accordionDetails}>
                  <Box className={styles.scrollableBox}>
                    <TableContainer component={Paper}>
                      <Table>
                        <TableHead>
                          <TableRow className={styles.tableHeader}>
                            <TableCell className={styles.tableCell}>
                              ADDRESS
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              STORE MANAGER
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              DRIVER DETAILS
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              PRODUCT TYPE
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              JOB PAY
                            </TableCell>
                            {/* Conditionally render RECCE REPORT column */}
                            {isRecceNeeded && (
                              <TableCell className={styles.tableCell}>
                                RECCE REPORT
                              </TableCell>
                            )}
                            <TableCell className={styles.tableCell}>
                              JOB STATUS
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {batch.jobs.map((row, index) => (
                            <TableRow key={index}>
                              <TableCell className={styles.tableCell}>
                                <div className={styles.sharedTextStyle}>
                                  {row?.storeName || "NA"}
                                </div>
                                <div className={styles.address2}>
                                  {row?.address || "NA"}
                                </div>
                              </TableCell>
                              <TableCell className={styles.tableCell}>
                                <div className={styles.sharedTextStyle}>
                                  {row.storeOwnerName}
                                </div>
                                <div className={styles.storeManagerContact}>
                                  {row.storeOwnerPhoneNumber}
                                </div>
                              </TableCell>

                              {/* <TableCell className={styles.tableCell}>
                                <div className={styles.sharedTextStyle}>
                                  {row.driverName}
                                </div>
                                <div className={styles.address2}>
                                  {row.driverNumber} | {row.driverVehicleNumber}
                                </div>
                              </TableCell> */}
                              <TableCell className={styles.tableCell}>
                                <div className={styles.sharedTextStyle}>
                                  {row.driverDetails?.driverName || "NA"}
                                </div>
                                <div className={styles.address2}>
                                  {row.driverDetails?.driverPhoneNumber || "NA"}{" "}
                                  | {row.driverDetails?.vehicleNumber || "NA"}
                                </div>
                              </TableCell>
                              <TableCell className={styles.tableCell}>
                                <div className={styles.sharedTextStyle}>
                                  {row?.productId?.productType || "NA"}
                                </div>
                              </TableCell>
                              {/* <TableCell className={styles.tableCell}>
                                <div className={styles.sharedTextStyle}>
                                  {row.jobDate}
                                </div>
                              </TableCell> */}
                              <TableCell className={styles.tableCell}>
                                <div className={styles.sharedTextStyle}>
                                  ₹{row.paymentAmount}
                                </div>
                              </TableCell>
                              {/* <TableCell className={styles.tableCell}>
                                <div className={styles.sharedTextStyle}>
                                  {row.kamApproval}
                                </div>
                              </TableCell>
                              <TableCell className={styles.tableCell}>
                                <div className={styles.sharedTextStyle}>
                                  {row.clientApproval}
                                </div>
                              </TableCell> */}
                              {/* Conditionally render recce report cell */}
                              {isRecceNeeded && (
                                <TableCell className={styles.tableCell}>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => handleOpenRecceReport(row)}
                                  >
                                    <img
                                      src={PdfIcon}
                                      alt="PDF Icon"
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        marginRight: "8px",
                                      }}
                                    />
                                    <a
                                      href="#"
                                      style={{
                                        cursor: "pointer",
                                        textDecoration: "none",
                                        color: "inherit",
                                      }}
                                    >
                                      {row.RecceReport}
                                    </a>
                                  </div>
                                </TableCell>
                              )}
                              <TableCell className={styles.tableCell}>
                                <Chip
                                  label={
                                    row.status === 0
                                      ? "pending"
                                      : row.status === 2
                                        ? "complete"
                                        : row.status
                                  }
                                  className={
                                    row.status === 2
                                      ? styles.amountPaid
                                      : row.status === 0
                                        ? styles.pending
                                        : ""
                                  }
                                />
                              </TableCell>
                              {/* <Chip label={row.ipPay} className={styles.pending}

                            /> */}
                              {/* <Chip
                                  label={row.ipPay}
                                  className={
                                    row.ipPay === "Paid"
                                      ? styles.amountPaid
                                      : styles.pending
                                  }
                                /> */}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                </AccordionDetails>
              </Accordion>
            </Grid>
          );
        })
      )}

      {openModalToUpdateBatch && (
        <ModalToUpdateBatches
          openModal={openModalToUpdateBatch}
          setOpenModalToUpdateBatch={setOpenModalToUpdateBatch}
          batch={detailsOfBatchSelected}
          setAvailableBatches={setAvailableBatches}
          fetchAllJobsBasedOnCampaignId={fetchAllJobsBasedOnCampaignId}
          fetchAllBatchesBasedOnCampaignId={fetchAllBatchesBasedOnCampaignId}
          isPaymentAmount={isPaymentAmount}
          onBatchUpdate={handleBatchUpdate}
          setAcceptedBatches={setAcceptedBatches}
          setIsNotAccepted={setIsNotAccepted}
          campaignData={campaignData}
        />
      )}
      {/* Recce Report Dialog */}
      <Dialog
        open={openRecceReport}
        onClose={handleCloseRecceReport}
        maxWidth="lg"
        fullWidth
        className="custom-dialog"
        PaperProps={{
          className: "custom-dialog-paper",
        }}
      >
        <DialogContent>
          {currentRecceJob && (
            <RecceReport
              setOpen={setOpenRecceReport}
              open={openRecceReport}
              currentApproval={currentRecceJob}
              finalSpaces={[]}
              installationCheck={true}
            />
          )}
        </DialogContent>
      </Dialog>
    </Grid>
  );
};

export default Incomplete;
